import { IUser } from "./user";
import { IDevice } from "./device";
import {
  FileVersionType,
  IChartResponse,
  IPolicyChartRecord,
} from "./dashboard";
import { IIdName } from "./id-name";
import { IRequestParams } from "./page";
import { IRepoDataMigration } from "./data-migration";

export enum StorageSpaceUnit {
  None = "",
  Mb = "mb",
  Gb = "gb",
  Tb = "tb",
}

export enum TimeLengthUnit {
  None = "",
  Hours = "hours",
  Days = "days",
  Months = "months",
  Years = "years",
}

export enum PolicySortField {
  Name = "name",
  Users = "users",
  Storage = "storage",
  Retention = "retention",
  Alerts = "alerts",
}

export enum LogoutTimer {
  Forever = 0,
  Minutes5 = 5,
  Minutes15 = 15,
  Minutes30 = 30,
  OneHour = 60
}

export interface IPolicyShort {
  id: number;
  name: string;
  StoragePool: IIdName;
  spaceLimitMegabytes: number;
  default?: boolean;
}

export interface IPolicy extends IPolicyShort, IPolicyRetention {
  dataMigrations?: IRepoDataMigration[];
  Devices: IDevice[];
  StorageNodes: IIdName[];
  Users: IUser[];
  bkcycle: number;
  createdAt: string;
  hasrecovery: number;
  maxDevice: number;
  permanentDelete: boolean;
  shouldnotify: boolean;
  spaceLimitMegabytes: number;
  updatedAt: string;
  allowOfflineFiles: boolean;
  localAuthentication: boolean;
  logoutTimer: LogoutTimer;
  type: number;
  notifyamount: number;
  notifyUsers: boolean;
  notifyAdmins: boolean;
}

export interface IUpdateUsersRequest {
  ids: number[];
}

export interface IDeletePoliciesRequest {
  id: number[];
  force?: boolean;
}

export interface IStorageUsagePerProfileRequest {
  fileVersionTypeIds: FileVersionType[];
}

export interface IStorageUsagePerProfileResponse
  extends IChartResponse<IPolicyChartRecord> {}

export interface IPolicyRetention {
  retainDeletedFiles: boolean;
  retainPreviousVersion: boolean;
  deletedFilesRetentionMegabytes: number;
  previousVersionRetentionMegabytes: number;
  deletedFilesRetentionDays: number;
  previousVersionRetentionDays: number;
}

export interface IPolicyUpdate extends Omit<IPolicyShort, "StoragePool">, IPolicyRetention {
  storagePoolId: number;
  spaceLimitMegabytes: number;
  shouldnotify: boolean;
  allowOfflineFiles: boolean;
  localAuthentication: boolean;
  logoutTimer: LogoutTimer
  notifyamount: number;
  selectedUsers?: number[];
}

export interface IPolicyAdd extends Omit<IPolicyUpdate, 'id'> {
}

export interface IPolicyFilterParams {
  q?: string;
  storagePoolFilter?: number;
}

export interface IPoliciesRequestParams extends IRequestParams<PolicySortField>, IPolicyFilterParams {
}

